import React from 'react';
import { Routes, Route, Link, useSearchParams } from 'react-router-dom';
import EcommerceDashboardAdvanced from './EcommerceDashboardAdvanced';
import EcommerceDashboardBasic from './EcommerceDashboardBasic';

const VersionSwitcherEcommerce: React.FC<{ currentVersion: string }> = ({ currentVersion }) => {
  return (
    <div className="version-switcher-ecommerce" style={{
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(10px)',
      padding: '20px',
      margin: '20px',
      borderRadius: '15px',
      textAlign: 'center',
      border: '1px solid rgba(255, 255, 255, 0.2)'
    }}>
      <h3 style={{ color: 'white', marginBottom: '20px', fontSize: '1.2rem' }}>Compare Versions:</h3>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
        <Link 
          to="?version=1.0" 
          style={{
            padding: '12px 24px',
            borderRadius: '25px',
            textDecoration: 'none',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            border: '2px solid transparent',
            background: currentVersion === '1.0' ? 'rgba(255, 107, 107, 0.8)' : 'rgba(255, 107, 107, 0.6)',
            color: 'white',
            borderColor: '#ff6b6b',
            transform: currentVersion === '1.0' ? 'scale(1.05)' : 'scale(1)',
            boxShadow: currentVersion === '1.0' ? '0 5px 15px rgba(0, 0, 0, 0.3)' : 'none'
          }}
        >
          Synoppy 1.0 - Basic
        </Link>
        <Link 
          to="?version=1.5" 
          style={{
            padding: '12px 24px',
            borderRadius: '25px',
            textDecoration: 'none',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            border: '2px solid transparent',
            background: currentVersion === '1.5' ? 'rgba(162, 155, 254, 0.8)' : 'rgba(162, 155, 254, 0.6)',
            color: 'white',
            borderColor: '#a29bfe',
            transform: currentVersion === '1.5' ? 'scale(1.05)' : 'scale(1)',
            boxShadow: currentVersion === '1.5' ? '0 5px 15px rgba(0, 0, 0, 0.3)' : 'none'
          }}
        >
          Synoppy 1.5 - Advanced
        </Link>
      </div>
    </div>
  );
};

const EcommerceAbout: React.FC = () => {
  return (
    <div style={{ padding: '20px', background: 'linear-gradient(135deg, #a29bfe, #6c5ce7)', minHeight: '100vh', color: 'white' }}>
      <Link to="/ecommerce-dashboard" style={{ color: 'white' }}>← Back to Dashboard</Link>
      <h1>About E-commerce Dashboard</h1>
      <div style={{ background: 'rgba(0,0,0,0.2)', padding: '20px', borderRadius: '10px', margin: '20px 0' }}>
        <h2>Prompt</h2>
        <p>"Build an e-commerce dashboard with analytics"</p>
      </div>
      <Link to="/" style={{ color: 'white' }}>Home</Link>
    </div>
  );
};

const EcommerceDashboard: React.FC = () => {
  const [searchParams] = useSearchParams();
  const version = searchParams.get('version') || '1.5';
  
  if (version === '1.0') {
    return (
      <div style={{ background: 'linear-gradient(135deg, #a29bfe, #6c5ce7)', minHeight: '100vh' }}>
        <Routes>
          <Route path="/" element={
            <div>
              <VersionSwitcherEcommerce currentVersion="1.0" />
              <EcommerceDashboardBasic />
            </div>
          } />
          <Route path="/about" element={<EcommerceAbout />} />
        </Routes>
      </div>
    );
  }
  
  return (
    <Routes>
      <Route path="/" element={
        <div>
          <VersionSwitcherEcommerce currentVersion="1.5" />
          <EcommerceDashboardAdvanced />
        </div>
      } />
      <Route path="/about" element={<EcommerceAbout />} />
    </Routes>
  );
};

export default EcommerceDashboard;